<div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">
        <ng-container>
          Edit Service Parameter
        </ng-container>
      </h4>
      <button type="button" class="close" (click)="close()">×</button>
    </div>
    <div class="modal-body">
      <div class="card-box">
        <form class="form-horizontal" role="form" autocomplete="off">
            <div class="form-group row">
                <label for="service" class="col-4 col-form-label">Service Parameter Name</label>
                <div class="col-8">
                    <input [(ngModel)]="serviceParameter.name" [ngModelOptions]="{standalone: true}" id="service" required class="form-control">
                </div>
            </div>
        </form>
        <div class="form-group mb-0 justify-content-end row">
          <div class="col-9">
            <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  